import React from 'react';
import { Grid } from '@mui/material';

const HeaderLogo = () => (
    <Grid display="flex" flexDirection="column" alignItems="center" justifyContent="center" mt="36px">
        <Grid width="100px" height="100px" display="flex" alignItems="center" justifyContent="center">
            <img src="/assets/images/AltynLogo.svg" alt="" style={{ width: '100%', height: '100%' }} />
        </Grid>
    </Grid>
);

export default HeaderLogo;
